import {
  WebsiteBackgroundPictureForSaveInterface,
  WebsiteBackgroundPictureInterface,
  WebsiteThemeBackgroundForSaveInterface,
  WebsiteThemeForSaveInterface,
  WebsiteThemeHeaderAndFooterForSaveInterface,
  WebsiteThemeInterface,
} from 'src/shared/types/website-settings-types'

const normalizePictureForSave = (
  pic: WebsiteBackgroundPictureInterface,
): WebsiteBackgroundPictureForSaveInterface => ({
  fileId: pic?.file?.id ?? pic.fileId ?? null,
  background: pic.background,
})

export const transformWebsiteTheme = (
  theme: WebsiteThemeInterface,
): WebsiteThemeForSaveInterface => {
  const { isCommon, background, headerAndFooter, ...rest } =
    theme as WebsiteThemeInterface

  const backgroundForSave: WebsiteThemeBackgroundForSaveInterface = {
    ...background,
    pageBackgroundPicture: normalizePictureForSave(
      background.pageBackgroundPicture,
    ),
  }

  const headerAndFooterForSave: WebsiteThemeHeaderAndFooterForSaveInterface = {
    ...headerAndFooter,
    headerBackgroundPicture: normalizePictureForSave(
      headerAndFooter.headerBackgroundPicture,
    ),
    footerBackgroundPicture: normalizePictureForSave(
      headerAndFooter.footerBackgroundPicture,
    ),
  }

  return {
    ...rest,
    background: backgroundForSave,
    headerAndFooter: headerAndFooterForSave,
  }
}
